(function () {
  var SELECTOR = '[data-mystic-footer-reveal]';
  var active = new Set();
  var ticking = false;

  function isMobileViewport() {
    return window.matchMedia('(max-width: 1023px)').matches;
  }

  function shouldRun(footer) {
    var isMobile = isMobileViewport();
    var mobileEnabled = footer.getAttribute('data-footer-reveal-mobile') === 'true';
    var desktopEnabled = footer.getAttribute('data-footer-reveal-desktop') === 'true';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    return isMobile ? mobileEnabled : desktopEnabled;
  }

  function resetFooter(footer) {
    footer.style.removeProperty('--mystic-footer-reveal-progress');
    footer.classList.remove('mystic-footer-reveal--active');
  }

  function updateFooter(footer) {
    if (!shouldRun(footer)) {
      resetFooter(footer);
      return;
    }

    var rect = footer.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var travel = Math.max(rect.height, 1);
    var progress = (viewportHeight - rect.top) / travel;
    progress = Math.max(0, Math.min(1, progress));

    footer.style.setProperty('--mystic-footer-reveal-progress', progress.toFixed(4));
    footer.classList.toggle('mystic-footer-reveal--active', progress > 0 && progress < 1);
  }

  function updateAll() {
    ticking = false;
    active.forEach(updateFooter);
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateAll);
  }

  function collect() {
    active.clear();
    document.querySelectorAll(SELECTOR).forEach(function (footer) {
      active.add(footer);
      updateFooter(footer);
    });
  }

  document.addEventListener('DOMContentLoaded', collect);
  document.addEventListener('shopify:section:load', collect);
  document.addEventListener('shopify:section:unload', collect);
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
})();
